module.exports = __webpack_public_path__ + "img/csv_import.1f3b1f1f.svg";